module.exports = __webpack_public_path__ + "static/2.7b45c21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/2.png
// module id = 824
// module chunks = 39236203315009 172526442442348